import {
    AppBar,
    Box,
    Button,
    Drawer,
    IconButton,
    List,
    ListItemButton,
    ListItemText,
    Toolbar,
    Typography,
    useMediaQuery,
    useTheme,
    Divider,
    Grow,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Link as RouterLink } from "react-router-dom";
import { useState } from "react";
import { ThemeToggleButton } from "../style/ThemeToggleButton";

export function Header() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [open, setOpen] = useState(false);

    const navItems = [
        { label: "Home", to: "/" },
        //{ label: "Categories", to: "/admin/categories" },
        { label: "Recipes", to: "/admin/recipes" },
    //    { label: "Admin Login", to: "/admin/login" },
    ];

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <AppBar position="sticky">
                <Toolbar sx={{ minHeight: { xs: 56, sm: 64 } }}>
                    {/* Mobile menu toggle */}
                    {isMobile && (
                        <IconButton
                            edge="start"
                            onClick={open ? handleClose : handleOpen}
                            aria-label={open ? "Close menu" : "Open menu"}
                            sx={{
                                mr: 1, 
                                transform: open ? "rotate(90deg)" : "rotate(0deg)",
                            }}
                        >
                            {open ? <CloseIcon sx={{color: "white !important"}} /> : <MenuIcon />}
                        </IconButton>
                    )}

                    <Typography
                        variant="h6"
                        component={RouterLink}
                        to="/"
                        onClick={handleClose}
                        sx={{
                            flexGrow: 1,
                            textDecoration: "none",
                            color: "inherit",
                            fontWeight: 800,
                            letterSpacing: 0.3,
                        }}
                    >
                        Recipe App
                    </Typography>

                    {/* Desktop navigation */}
                    {!isMobile && (
                        <Box sx={{ display: "flex", gap: 1 }}>
                            {navItems.map((item) => (
                                <Button
                                    key={item.label}
                                    component={RouterLink}
                                    to={item.to}
                                >
                                    {item.label}
                                </Button>
                            ))}
                        </Box>
                    )}

                    {/* Theme toggle */}
                    <Box sx={{ ml: 1 }}>
                        <ThemeToggleButton />
                    </Box>
                </Toolbar>
            </AppBar>

            {/* Mobile Drawer */}
            <Drawer
                anchor="left"
                open={open}
                onClose={handleClose}
                transitionDuration={{ enter: 220, exit: 180 }}
            >
                {/* Drawer header */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        px: 2,
                        py: 1.5,
                    }}
                >
                    <Typography sx={{ fontWeight: 900 }}>
                        Menu
                    </Typography>

                    <Grow in={open} timeout={200}>
                        <IconButton onClick={handleClose} aria-label="Close menu">
                            <CloseIcon />
                        </IconButton>
                    </Grow>
                </Box>

                <Divider />

                {/* Drawer menu items */}
                <List >
                    {navItems.map((item) => (
                        <ListItemButton
                            key={item.label}
                            component={RouterLink}
                            to={item.to}
                            onClick={handleClose}
                            
                        >
                            <ListItemText
                                primary={item.label}
                                primaryTypographyProps={{ fontWeight: 700 }}
                            />
                        </ListItemButton>
                    ))}
                </List>

                <Box sx={{ mt: "auto", px: 2, pb: 2, opacity: 0.7 }}>
                    <Typography variant="caption">
                        &copy; {new Date().getFullYear()} Recipe App
                    </Typography>
                </Box>
            </Drawer>
        </>
    );
}
